import React, { useState } from 'react';
import NCZISetupModalContent from './NCZISetupModalContent';
import Button from '../../../../Components/Button/Button';
import { Size } from '../../../../Enums/Size.enum';
import NCZIWizardModal from '../NCZIWizard/NCZIWizardModal';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';

const NCZISetupModal: React.FC<BaseModalProps> = props => {
	const [settingsOpen, setSettingsOpen] = useState(false);
	const [instructionsModalOpen, setInstructionsModalOpen] = useState(false);

	return (
		<>
			<BaseModal {...props} title='component.nczi.setup.button' size={Size.MD}>
				<>
					{settingsOpen ? (
						<>
							<NCZISetupModalContent onClose={() => setSettingsOpen(false)} />
						</>
					) : (
						<>
							<Button
								onClick={() => setInstructionsModalOpen(true)}
								title='component.nczi.setupInstructions.button'
								theme='blue'
							/>
							<Button
								onClick={() => setSettingsOpen(true)}
								title='component.nczi.setupOnlySettings.button'
								theme='blue'
								className='mt-4'
							/>
						</>
					)}
				</>
			</BaseModal>
			{instructionsModalOpen && (
				<NCZIWizardModal
					isOpen
					onClose={() => setInstructionsModalOpen(false)}
				/>
			)}
		</>
	);
};

export default NCZISetupModal;
